export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6937.699a3e76.jpg";